import React, { Component } from 'react'
import { GlgLabel, GlgDropdown } from 'SharedComponents'
import { Row, Col } from 'react-flexbox-grid'
import PropTypes from 'prop-types'


class SummaryComponent extends Component {
  constructor(props){
    super(props)
    this.state = {}

    this.buildActions = this.buildActions.bind(this)
    this.getQualifyingRecipients = this.getQualifyingRecipients.bind(this)
  }

  buildActions() {
    const {
      marketingCampaign,
    } = this.props
    
    let statusLabel = ''
    switch (marketingCampaign.status){
      case 'running':
        statusLabel = window.I18n.t('marketing_campaigns.components.summary_component.pause')
        break
      case 'paused':
        statusLabel = window.I18n.t('marketing_campaigns.components.summary_component.run')
        break
      case 'completed':
        statusLabel = window.I18n.t('marketing_campaigns.components.summary_component.run_again')
    }

    const ACTION_ITEMS = [
      {
        url: `/customers/${marketingCampaign.customer_id}/marketing_campaigns/${marketingCampaign.id}/edit`,
        label: window.I18n.t('marketing_campaigns.components.summary_component.edit'),
      },
      {
        url: `/customers/${marketingCampaign.customer_id}/marketing_campaigns/${marketingCampaign.id}/delivery_reports`,
        label: window.I18n.t('marketing_campaigns.components.summary_component.delivery_reports'),
      },
      {
        onClick: this.props.changeStatus,
        label: statusLabel,
      },
      {
        onClick: () => {
          // eslint-disable-next-line no-alert
          if (window.confirm(window.I18n.t('marketing_campaigns.components.summary_component.delete_confirmation', { campaign_name: marketingCampaign.name }))) {
            this.props.handleDelete()
          }
        },
        label: window.I18n.t('marketing_campaigns.components.summary_component.delete'),
      },
    ]

    return ACTION_ITEMS
  }

  labelType(marketingCampaignStatus) {
    switch (marketingCampaignStatus){
      case 'running':
        return 'success'
      case 'paused':
        return 'warning'
      case 'completed':
        return 'primary'
    }
  }

  componentDidMount() {
    this.getQualifyingRecipients()
  }

  getQualifyingRecipients() {
    const {
      matchingRecipientsPath,
      marketingCampaign,
    } = this.props

    $.ajax({
      url: matchingRecipientsPath,
      dataType: 'json',
      data: {
        format: 'json',
        'marketing_campaign_id': marketingCampaign.id,
      },
      type: 'POST',
      success: (response) => {
        this.setState({
          ...this.state,
          qualifyingRecipients: response['matching_recipients_count'],
        })
      },
      error: () => {
        // eslint-disable-next-line no-console
        console.log('Error qualifying recipients')
      },
    })
  }

  render() {
    const {
      marketingCampaign,
    } = this.props

    const ACTION_ITEMS = this.buildActions()
    const hasEmailTemplate = !!marketingCampaign.email_template_id

    return (
      <Row id='marketing-campaign-summary' className='no-margin'>
        <Col id='campaign-name' className='with_separators vertical-align' xs={ 12 } sm={ 6 } lg={ 2 }>
          <Row className='no-margin font-size-15'>
            <strong>
              {marketingCampaign.name}
            </strong>
          </Row>
          <Row className='no-margin capitalize'>
            <GlgLabel type={this.labelType(marketingCampaign.status)}>
              {!window.I18n ? '' : window.I18n.t(`marketing_campaigns.components.summary_component.status.${marketingCampaign.status}`, {defaultValue: marketingCampaign.status})}
            </GlgLabel>
          </Row>
        </Col>
        <Col id='campaign-actions' className='with_separators vertical-align hidden-lg' xs={ 12 } sm={ 6 } lg={ 2 }>
          <Row>
            <strong className='add-margin-right-15'>
              { window.I18n.t('marketing_campaigns.components.summary_component.actions') }
            </strong>
            <GlgDropdown items={ ACTION_ITEMS } direction="left" />
          </Row>
        </Col>
        <Col id='md-separator' className='revert-grid hidden-xs hidden-lg' xs={ 12 }>
          <Row>
            <Col xs={ 6 }>
              <div></div>
            </Col>
            <Col xs={ 6 }>
              <div></div>
            </Col>
          </Row>
        </Col>
        <Col id='campaign-details' className='revert-grid with_separators vertical-align' xs={ 12 } sm={ 6 } lg={ 5 }>
          <Col xs={8}>
            <Row className='no-margin'>
              <strong>
                { window.I18n.t('marketing_campaigns.components.summary_component.schedule') }
              </strong>
              {marketingCampaign.schedule_time}
            </Row>
            <Row className='no-margin'>
              <strong>
                { window.I18n.t('marketing_campaigns.components.summary_component.qualifying_recipients') }
              </strong>
              { this.state.qualifyingRecipients || window.I18n.t('marketing_campaigns.components.summary_component.calculating') }
            </Row>
            { marketingCampaign.email_template_name && (
              <Row className='no-margin'>
                <strong>
                  { window.I18n.t('marketing_campaigns.components.summary_component.email_template') }
                </strong>
                { marketingCampaign.email_template_name }
              </Row>
            )}
            { marketingCampaign.text_template_name && (
              <Row className='no-margin'>
                <strong>
                  { window.I18n.t('marketing_campaigns.components.summary_component.text_template') }
                </strong>
                { marketingCampaign.text_template_name }
              </Row>
            )}
          </Col>
        </Col>
        <Col id='stats-details' xs={ 12 } sm={ 6 } lg={ 3 } className={ `vertical-align ${hasEmailTemplate ? 'with_separators' : ''}`}>
          { hasEmailTemplate && (
            <Row className='no-margin vertical-align'>
              <Col xs={ 6 }>
                <div id='opens' className='percentage-box'>
                  <div className='font-size-30'>
                    { marketingCampaign.opens + '%' }
                  </div>
                  <strong>
                    { !window.I18n ? '' : window.I18n.t('marketing_campaigns.components.summary_component.opens') }
                  </strong>
                </div>
              </Col>
              <Col xs={ 6 }>
                <div id='clicks' className='percentage-box'>
                  <div className='font-size-30'>
                    { marketingCampaign.clicks + '%' }
                  </div>
                  <strong>
                    { window.I18n.t('marketing_campaigns.components.summary_component.clicks') }
                  </strong>
                </div>
              </Col>
            </Row>
          )}
        </Col>
        <Col id='campaign-actions' lg={ 2 } className={`vertical-align hidden-xs hidden-sm hidden-md ${hasEmailTemplate ? '' : 'with_separators'}`}>
          <Row>
            <strong className='add-margin-right-15'>
              { window.I18n.t('marketing_campaigns.components.summary_component.actions') }
            </strong>
            <GlgDropdown items={ ACTION_ITEMS } direction="left" />
          </Row>
        </Col>
      </Row>
    )
  }
}

SummaryComponent.propTypes = {
  matchingRecipientsPath: PropTypes.string.isRequired,
  marketingCampaign: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
}

export default SummaryComponent
